import { Injectable } from '@angular/core';
import { GlobalClassInstance } from '@commoncore/constants/GlobalClass';
import { UniversalService } from '@commoncore/services/universal.service';
import { ENV_CONSTANTS } from '@env-properties/environment';
import { USER_DETAILS } from '@mainrepo/app/core/constants/Constants';
import { ListService } from './list.service';


@Injectable({
  providedIn: 'root'
})
export class CustomMetadataService {
  public imageArray: any = [];
	public audioArray: any = [];
	public videoArray: any = [];
	public otherDocs: any = [];
	public folderArray: any = [];
	public allData: any = [];
	public mixedObjects:any=[];
	public allArrays: any = [];
	public currentDate = new Date();
	currentTab = "";
	public months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  	public weekDays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
	public excelFormats = ["xlsx","xls","csv","ods","xlsb","xlsm","xltx","numbers"];
	public wordFormats = ["docx","doc","docm","dot","dotm","dotx","odt","rtf","vsdx","vsd","vssx","vstx","visio"];
	public powerPointFormats = ["pptx","ppt","odp","pptm","pot","potm","ppsm","ppsx","potx","pps"];
	public pdfFormats = ["pdf","ai","dxf","psd","ps"];
	public textFormats = ["txt","html","md","less","vcf","pages","xml","c","cpp","css","hpp","h","js","php","key","svg"];
	public libreOfficeList = ["doc","docx","docm","dot","dotm","dotx","xlsx","xls","csv","ods","pptx","ppt","odp","pptm","pot","potm","ppsm","ppsx","potx","pps","txt","html","md","less","vcf","pages","xml","c","cpp","css","hpp","h","js","php","key","svg","odt","xlsb","xlsm","xltx","numbers","rtf","one","onetoc2","note","whiteboard","fluid","vsdx","vsd","vssx","vstx","visio"]
	public officeFormats = ["wopitest","wopitestx","one","onetoc2","note","whiteboard","fluid"]
	MSOfficeImages = {
		".xlsx":"assets/images/xlsx.svg",
		".xls":"assets/images/xls.svg",
		".csv":"assets/images/xlsx.svg",
		".ods":"assets/images/ods.svg",
		".xlsb":"assets/images/xlsx.svg",
		".xlsm":"assets/images/xlsx.svg",
		".xltx":"assets/images/xltx.svg",
		".numbers":"assets/images/xlsx.svg",
		".docx":"assets/images/docx.svg",
		".doc":"assets/images/docx.svg",
		".docm":"assets/images/docx.svg",
		".dot":"assets/images/docx.svg",
		".dotm":"assets/images/docx.svg",
		".dotx":"assets/images/dotx.svg",
		".odt":"assets/images/odt.svg",
		".rtf":"assets/images/docx.svg",
		".vsd":"assets/images/vsdx.svg",
		".vsdx":"assets/images/vsdx.svg",
		".vstx":"assets/images/vstx.svg",
		".visio":"assets/images/visio.svg",
		".vssx":"assets/images/vssx.svg",
		".pptx":"assets/images/pptx.svg",
		".ppt":"assets/images/ppt.svg",
		".odp":"assets/images/odp.svg",
		".pptm":"assets/images/pptx.svg",
		".pot":"assets/images/pptx.svg",
		".potm":"assets/images/pptx.svg",
		".ppsm":"assets/images/pptx.svg",
		".ppsx":"assets/images/ppsx.svg",
		".potx":"assets/images/potx.svg",
		".pps":"assets/images/pptx.svg",
		".wopitest":"assets/images/office_default.svg",
		".wopitestx":"assets/images/office_default.svg",
		"word_default":"assets/images/docx.svg",
		"excel_default":"assets/images/xlsx.svg",
		"powerpoint_default":"assets/images/pptx.svg",
		"office_default":"assets/images/office_default.svg",
	  }



  constructor(public universalService:UniversalService,public listService:ListService) {
   }

   segregateData(success,currentTab) {
	  this.currentTab = currentTab;
	  var url = window.location.href;
		var self = this;
		this.allData = [];
		this.mixedObjects = []
		this.imageArray = [];
		this.folderArray = [];
		this.videoArray = [];
		this.audioArray = [];
		this.otherDocs = [];
		this.allArrays = [];
		this.universalService.allTypesOfObj = [];
		this.allData = success["objects"]? success["objects"] : (success["files"] ? success["files"] : success["shares"] ? success["shares"] : success);
		this.getCreatedDates(this.allData);
		this.setFormatType(this.allData);
		this.calculateSizes();
		this.setDuration();
		if((currentTab && !currentTab.includes("search")) && (url.includes('/shared') || url.includes('/share')) && (this.universalService.popUpToBeOpened =="" || this.universalService.popUpToBeOpened == 'create Folder')){
			this.setAccessRights(this.allData);
		}

		this.setDefaultIconThumbnailAndIconClasses(this.allData);
		if(currentTab == "sharedlinkbyme") {
			this.setMandatoryParamsToDisplayThubmnails();
			return this.allData;
		}
		this.allData.map(function (object) {
			let type = self.universalService.checkIfImgTypeParamIsRequired(object["mimeSubType"]);
			if(object["version"]){
			 object["latestVersion"] = object["version"]
			}
			// if (!object['alreadyinverted'] && object.orientation != undefined && (object.orientation.indexOf("90") != -1 || object.orientation.indexOf("270") != -1)) {
			// 	let actualHeight = object["height"];
			// 	let actualWidth = object["width"];
			// 	object["width"] = actualHeight;
			// 	object["height"] = actualWidth;
			// 	object['alreadyinverted'] = true
			// }
			if(self.universalService.popUpToBeOpened.length==0){ // && currentTab!='allfilessearch' && currentTab!='search-suggestions' 
				if(currentTab!='allfilesRecent')
					self.universalService.mobileSelectedObj.push(object)// movile select all only 
				else
					self.universalService.recentMobileSelectedObj.push(object)
			}			
			if (object.objectType == "FR" || object.objectType == "BR") {
				self.folderArray.push(object)
			} else if (object.objectType == "FE" || object.objectType == "BE" || object.objectType == "DE" || object.objectType == "BB" || object.objectType == "SE") {
				if(!object["imageTranscodeURLIsAlreadyFormed"]){
				object["imageTranscodeURLIsAlreadyFormed"] = true;
				if(object["placeCoverPicURL"]){
					object["previewTranscodeUrl"] = object["placeCoverPicURL"];
				}else if(object["thumbnailURL"]){
					object["previewTranscodeUrl"] = object["thumbnailURL"];
				}else{
					object["previewTranscodeUrl"] = object["imageTranscodeUrl"] ? object["imageTranscodeUrl"] : object["url"];
				}
				if((object.mimeType != 'image' && object.mimeType != 'audio' && object.mimeType != 'video') && !self.universalService.inAppWebViewOpened) {
					/*if (object["mimeSubType"] == "pdf") {
						// if(object["imageTranscodeUrl"]){
						// 	var imageUrl = object["imageTranscodeUrl"];
						// 	imageUrl = imageUrl.includes('?') ? imageUrl + '&': imageUrl + '?';
						// 	let url = imageUrl + 'size=a&apiKey=' + ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-Api-Key"] + '&devicetype=web' + type;
						// 	object["imageTranscodeUrl"] = url;
						// }else{
						// 	object["imageTranscodeUrl"]=''
						// }
						var pdfUrl = object["url"]?object["url"]:"";
						pdfUrl = pdfUrl.includes('?') ? pdfUrl + '&': pdfUrl + '?';
						let url = pdfUrl + "apiKey=" + ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-Api-Key"] + "&size=l&devicetype=web&version=" + (object["version"]?object["version"]:1).toString() //&ts=" + new Date().getTime(); // if the object is pdf ot any other doc 
						object.url = url;
					} else {
						let url = object["url"] + "&apiKey=" + ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-Api-Key"] + "&devicetype=web&ts=" + new Date().getTime(); // if the object is pdf ot any other doc
						if(self.universalService.currentTab == "PrivateFolder"){
							url = url + "&ppftoken="+encodeURIComponent(self.universalService.header_X_PPF_TOKEN);
						}
						object["imageTranscodeUrl"] = url;
					}*/
					if (object["mimeSubType"] == "pdf") {
                        var pdfUrl = object["url"]?object["url"]:"";
                        pdfUrl = pdfUrl.includes('?') ? pdfUrl + '&': pdfUrl + '?';
                        let url = pdfUrl + "apiKey=" + ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-Api-Key"] + "&size=l&devicetype=web&version=" + (object["version"]?object["version"]:1).toString() //&ts=" + new Date().getTime(); // if the object is pdf ot any other doc
                        object.url = url;
                    }

					let url = object["previewTranscodeUrl"];
					if (object["imageTranscodeUrl"]){
						var imageUrl = object["imageTranscodeUrl"];
						imageUrl = imageUrl.includes('?') ? imageUrl + '&': imageUrl + '?';
						url = imageUrl + 'size=n&apiKey=' + ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-Api-Key"] + '&devicetype=web' + type;
						if(self.universalService.currentTab == "PrivateFolder"){
							url = url + "&ppftoken="+encodeURIComponent(self.universalService.header_X_PPF_TOKEN);
						}
					}
					object["imageTranscodeUrl"] = url;
				}
				if (self.universalService.listView) {
					if (object.mimeType == 'image' || object.mimeType == 'audio' || object.mimeType == 'video') {
						var imageUrl = object["previewTranscodeUrl"];
						imageUrl = imageUrl.includes('?') ? imageUrl + '&': imageUrl + '?';
						let url = imageUrl + 'size=a&apiKey=' + ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-Api-Key"] + '&devicetype=web' + type;
						if(self.universalService.currentTab == "PrivateFolder"){
							url = url + "&ppftoken="+encodeURIComponent(self.universalService.header_X_PPF_TOKEN);
						}
						object["imageTranscodeUrl"] = url;
					}
				} else if (!self.universalService.listView) {
					if (object.mimeType == 'image' || object.mimeType == 'audio' || object.mimeType == 'video') {
						let imageUrl = object["previewTranscodeUrl"];
						imageUrl = imageUrl.includes('?') ? imageUrl + '&': imageUrl + '?';
						let url = imageUrl + "size=c&apiKey=" + ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-Api-Key"] + '&devicetype=web' + type;
						if(self.universalService.currentTab == "PrivateFolder"){
							url = url + "&ppftoken="+encodeURIComponent(self.universalService.header_X_PPF_TOKEN);
						}
						object["imageTranscodeUrl"] = url;

					}
				}

				if(object.mimeType == 'video' && object["previewURL"]){
					let previewURL = object["previewURL"].includes('?') ? object["previewURL"] + '&': object["previewURL"] + '?';
					object["thumbnailPreviewUrl"] = previewURL +  "apiKey=" + ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-Api-Key"];
				}
				// if(object["imageTranscodeUrl"]){
				// 	object["imageTranscodeUrl"] = (object["imageTranscodeUrl"].split(".com"))[1];
				// 	//enable the below line for photo editing on local
				// 	// object["imageTranscodeUrl"] = window.location.origin + object["imageTranscodeUrl"] 
				// }

				// if(object["thumbnailPreviewUrl"]){
				// 	object["thumbnailPreviewUrl"] = (object["thumbnailPreviewUrl"].split(".com"))[1];
				// }
				 
				}
				self.mixedObjects.push(object)
				if(self.universalService.currentTab != 'People' && self.universalService.currentTab != 'Places' && self.universalService.currentTab != 'Home' && !self.universalService.showPreview && currentTab!='allfilesRecent'&& currentTab!='search-suggestions' && self.universalService.popUpToBeOpened != "copyPopUp" && self.universalService.popUpToBeOpened != "movePopUp"){
					// self.universalService.popUpToBeOpened == "copyPopUp and movePopUp" check is added to avoid pushing of the objects to objectsPreviewArray when data is fetched for modals like, move,copy which fetches both the 
					self.universalService.objectsPreviewArray.push(object)
				}else if(currentTab=='allfilesRecent'){
					
					self.universalService.recentFilesPreviewArray.push(object)
				}
				if (object.mimeType == 'image') {
					self.imageArray.push(object)
				} else if (object.mimeType == 'audio') {
					self.audioArray.push(object)
				} else if (object.mimeType == 'video') {
					self.videoArray.push(object)
				} else {
					self.otherDocs.push(object)
				}
			} else {
				//If search is face name create url 
				if(currentTab == "search-suggestions" && !object.objectType && !object.mimeType && (object.faceObjectKey || object.faceKey)) {
					let url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["downloadURL"] + "/download/images/" + (object.faceObjectKey ? object.faceObjectKey : object.faceKey) +
					"?apiKey=" + ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-Api-Key"] + '&devicetype=web' + type;
					object["imageTranscodeUrl"] = url;
				}
			}
		})
		
		if(currentTab == 'allfiles' && this.universalService.listView && !this.universalService.isMobileDevice){
			this.universalService.atPreviewfolderCount = this.folderArray.length;
		}
		this.universalService.allTypesOfObj = this.mixedObjects
		this.allArrays = this.folderArray.concat(this.mixedObjects)
		if (currentTab == 'allfiles' || currentTab == 'allfilesRecent') {
			// if(window.location.href.indexOf("/favorites/myfiles") > -1 ){
			// 	return  (this.universalService.popUpToBeOpened=='movePopUp'||this.universalService.popUpToBeOpened=='copyPopUp')?this.allArrays:this.mixedObjects
			// } else {
				return this.allArrays;
			// }
		} else if(currentTab == 'received' || currentTab == 'sent') {
			return this.allArrays;
		} else if (currentTab == 'photos') {
			return this.imageArray
		} else if (currentTab == 'audio') {
			return this.audioArray;
		} else if (currentTab == 'videos') {
			return this.videoArray;
		} else if (currentTab == 'docs') {
			return this.otherDocs; 
		} 
		// else if (currentTab == 'album-details'){
		// 	var object = {};
		// 	object["allfiles"] = this.allArrays;
		// 	object["photos"] = this.imageArray;
		// 	object["audio"] = this.audioArray;
		// 	object["videos"] = this.videoArray;
		// 	object["docs"] = this.otherDocs;
		// 	return object;
		// } 
		else if (currentTab == 'albums'){
			return this.allData;
		}else if (currentTab == 'search-suggestions'){
			return this.allData;
		}
	}

	getCreatedDates(dataArray) {
		var self = this;
		var utcSeconds, date, modifiedUtcSeconds,lastAccUtcSeconds,accessedDate,modifiedDate,shareCreatedDate,shareModifiedDate,uploadedSeconds,uploadDate;

		dataArray.map(function (object) {
			if (object["createdDate"] && (self.universalService.sharePublicSortByDate == "%2DcreatedDate" || self.universalService.isSortByUploadDate)) {
				utcSeconds = object["createdDate"];
			} else if (object["fileCreatedDate"]) {
				utcSeconds = object["fileCreatedDate"];
			} else if(object["createdTime"]){
				utcSeconds = object["createdTime"]
			}else{
				utcSeconds = object["createdDate"]
			}
			if(self.universalService.listView && !self.universalService.isMobileDevice && self.listService.listViewSortOrder.includes("fileCreatedDate") && object["fileCreatedDate"]){
				utcSeconds = object["fileCreatedDate"];
			}else if(self.universalService.listView && !self.universalService.isMobileDevice && self.listService.listViewSortOrder.includes("createdDate") && object["createdDate"]){
				utcSeconds = object["createdDate"];
			}
			if (object["lastModifiedDate"]) { // this needs to be changes after the server team changes the key name for now taking lastUpdatedTime into  consideration if lastModifiedDate is not there
				modifiedUtcSeconds = object["lastModifiedDate"]
			} else if(object["lastUpdatedTime"]){
				modifiedUtcSeconds = object["lastUpdatedTime"]
			} else if(object["lastUpdatedDate"]){
				modifiedUtcSeconds = object["lastUpdatedDate"]
			} else{
				modifiedUtcSeconds = object["createdDate"]
			}
			lastAccUtcSeconds = object["lastAccessedDate"] ? object["lastAccessedDate"]: modifiedUtcSeconds;
			
			var lad = new Date(lastAccUtcSeconds);
			object["lastAccessCol"] = self.setDateFormat(new Date(object["lastUpdatedDate"])); 
			if(object["favoriteDate"]){
				object["favDate"] = self.setDateFormat(new Date(object["favoriteDate"])); 
			}
			if(utcSeconds == undefined){
				object["createdOn"] = "-";
			}else{
				var d = new Date(utcSeconds);
				date = self.setDateFormat(utcSeconds)
				object["cMonthNo"] = d.getMonth();
				object["cYear"] = d.getFullYear();
				object["completeCreatedDate"] = d.getDate() + " " + self.months[d.getMonth()] + " " + object["cYear"];
				object["createdOn"] = self.weekDays[d.getDay()] + ", " + d.getDate() + " " + self.months[d.getMonth()] + " " + d.getFullYear() + ", " + d.getHours() + ":" + (d.getMinutes() < 10 ? '0' : '') + d.getMinutes();
				object["createdOnShort"] = d.getDate() + " " + self.months[d.getMonth()] + " " + d.getFullYear() + ", " + d.getHours() + ":" + (d.getMinutes() < 10 ? '0' : '') + d.getMinutes();
			}

			if(modifiedUtcSeconds == undefined){
				object["modifiedDate"] = "-";
				object["modifiedDateCol"] = "-";
			}else{
				var md = new Date(modifiedUtcSeconds);
				modifiedDate = self.setDateFormat(modifiedUtcSeconds)
				object["modifiedDateCol"] = modifiedDate;
				object["modMonthNo"] = md.getMonth();
				object["modYear"] = md.getFullYear();
				object["modifiedOn"] = self.weekDays[md.getDay()] + ", " + md.getDate() + " " + self.months[md.getMonth()] + " " + md.getFullYear() + ", " + md.getHours() + ":" + (md.getMinutes() < 10 ? '0' : '') + md.getMinutes();

			
			}
			
			
			accessedDate = self.setDateFormat(object["lastAccessedDate"]? object["lastAccessedDate"]: modifiedUtcSeconds)
			if(window.location.href.includes('shared')){
				object["shareCreatedDate"] = object["shareCreatedDate"]?object["shareCreatedDate"]:"-";
				object["shareModifiedDate"] = object["shareModifiedDate"]?object["shareModifiedDate"]:"-"
				shareCreatedDate = (object["shareCreatedDate"] != "-")?self.setDateFormat(object["shareCreatedDate"]):"-";
				shareModifiedDate = (object["shareCreatedDate"] != "-")?self.setDateFormat(object["shareModifiedDate"]):"-";
				if(self.universalService.isUserOnSharedLinkByMe) {
					object["objectKey"] = object["shareKey"]?object["shareKey"]:"-";
				}
			}
			object["lastAccMonthNo"] = lad.getMonth();
			object["lastAccYear"] = lad.getFullYear();
			if(object["fileCreatedDate"]!= undefined && self.universalService.listView && !self.universalService.isMobileDevice) {// on audio/doc it was assigning uploaded date in gridDate when sorted with that column, reason same dates were reflecting
				utcSeconds = object["fileCreatedDate"]
				var d = new Date(utcSeconds);
				object["gridDate"] = self.setDateFormat(utcSeconds);
			} else {
				object["gridDate"] = date;
			}
			object["accessedDate"] = accessedDate;
			object["modifiedDate"] = modifiedDate;
			object["sharedDate"] = shareCreatedDate;
			object["shareModified"] = shareModifiedDate;
			if (object["objectType"] == "FE" || object["objectType"] == "BE" || object["objectType"] == "DE" || object["objectType"] == "BB" || object["objectType"] == "SE") {
				if(object["createdDate"]){
					uploadedSeconds =  object["createdDate"];
					var ud = new Date(uploadedSeconds);
					uploadDate = self.setDateFormat(uploadedSeconds);
					object["uploadedOn"] = self.weekDays[ud.getDay()] + ", " + ud.getDate() + " " + self.months[ud.getMonth()] + " " + ud.getFullYear() + ", " + ud.getHours() + ":" + (ud.getMinutes() < 10 ? '0' : '') + ud.getMinutes();
					object["uploadedDate"] = object["uploadedOn"];
					object["uploadedDateCol"] = uploadDate;
					object["uMonthNo"] = ud.getMonth();
					object["uYear"] = ud.getFullYear();
					if(md<ud){
						object["modifiedLessThanUploadedDate"] = "true";	
					}else{
						object["modifiedLessThanUploadedDate"] = "false";	
					}
				}else{
					object["uploadedDate"] = object["createdOn"];
					if(md<=d){
						object["modifiedLessThanUploadedDate"] = "true";	
					}else{
						object["modifiedLessThanUploadedDate"] = "false";	
					}
				}
				
			} else if(object["objectType"] == "FR") { //For folders to show dates field wise, it was getting overridden
				if(object["createdDate"]){
					uploadedSeconds =  object["createdDate"];
					var ud = new Date(uploadedSeconds);
					uploadDate = self.setDateFormat(uploadedSeconds);
					object["uploadedDateCol"] = uploadDate;
				} 
				if(object["fileCreatedDate"]) {
					utcSeconds = object["fileCreatedDate"];
					var d = new Date(utcSeconds);
					date = self.setDateFormat(utcSeconds);
					object["gridDate"] = date;
				}
			}
		})
		return dataArray;
	}

	setDateFormat(utcSeconds){
		var date;
		var d = new Date(utcSeconds);
		if (d.getFullYear() == this.currentDate.getFullYear()) {
			date = d.getDate() + " " + this.months[d.getMonth()]
		} else {
			date = d.getDate() + " " + this.months[d.getMonth()] + " " + d.getFullYear()
		}
		return date
	}

	setFormatType(dataArray) {
		var self = this;
		var docEditSupportedExtensions = this.universalService.docEditSupportedExtensions ? this.universalService.docEditSupportedExtensions["supportedExtensions"] : {"view":[],"edit":[]};
		dataArray.map(function (object) {
			object["parentObjectType"] == "BR" || object["objectType"] == "BR" ? object["isBackeupItem"] = true :object["isBackeupItem"] = false;
				
			if (object["objectType"] == "FR" || object["objectType"] == "BR") {
				object["format"] = "Folder";
				object["extension"] = ""
				object["displayName"] = "Folder";
				object["isFavorite"]  = (object["isFavorite"] == 'Y')?true:(object["isFavorite"] == 'N'?false:object["isFavorite"])
				var objectName = object["objectName"]? object["objectName"] : (object["shareName"] ? object["shareName"]: (object["tfName"] ? object["tfName"]: ""));
				object["objectName"]  = objectName;
			} else {
				var extns ="";
				var objectName = object["objectName"]?object["objectName"]:(object["key"]?object["key"]: (object["shareName"]?object["shareName"]: (object["tfName"]?object["tfName"]: "")));
				object["objectName"]  = objectName
				object["isFavorite"]  = (object["isFavorite"] == 'Y')?true:(object["isFavorite"] == 'N'?false:object["isFavorite"])
				if(self.currentTab == 'albums'){
					objectName = object["boardName"]? object["boardName"] : "-";//if boardName is not provided in response
				}

				if(objectName.indexOf(".")>0){
					extns=objectName.split(".");
					object["extension"] = "." + extns[extns.length - 1];
				}else{
					object["extension"] = "";
				}
				
				if (self.universalService.isMobileDevice) {
					if (objectName.length > 14) {
						object["objectShortName"] = objectName.slice(0, 7) + "..." + (extns.length>0?extns[extns.length - 1]:"");
					} else {
						object["objectShortName"] = objectName
					}
				} else {
					if (objectName.length > 30) {
						object["objectShortName"] = objectName.slice(0, 20) + "..." + (extns.length>0?extns[extns.length - 1]:"")
					} else {
						object["objectShortName"] = objectName
					}
				}
				if (objectName.length > 20) {//show name irrespective of mobile which holds 8 & desktop hold 20 in 'objectShortName'
					object["trimmedObjectName"] = objectName.slice(0, 17) + "..." + (extns.length>0?extns[extns.length - 1]:"")
				} else {
					object["trimmedObjectName"] = objectName;
				}
				if (object["mimeType"] == "image" || object["mimeType"] == "audio" || object["mimeType"] == "video")
					object["format"]  = object["mimeType"]//object["displayName"]//
				else {
					//object["format"] = object["displayName"]
					if (extns.length == 0) { // case to handle default icons for share link tab listing
						object["format"]  = object["mimeType"];
						if(object["mimeType"] == undefined) {
							object["format"]  = "application";
						}
					}
					else {
						object["format"] = extns[extns.length - 1];
						if(self.libreOfficeList.includes(object["format"].toLowerCase())){
							object["libreOfficeSupported"] = true;
						}else{
							object["libreOfficeSupported"] = false;
						}
						if (self.wordFormats.includes(object["format"].toLowerCase())) {
							object["format"] = "Document";
							object["MSOfficeImage"] = self.MSOfficeImages[object["extension"]] ? self.MSOfficeImages[object["extension"]] : self.MSOfficeImages["word_default"];
						} else if (self.excelFormats.includes(object["format"].toLowerCase())) { 
							object["format"] = "SpreadSheet";
							object["MSOfficeImage"] = self.MSOfficeImages[object["extension"]] ? self.MSOfficeImages[object["extension"]] : self.MSOfficeImages["excel_default"];
						} else if (self.pdfFormats.includes(object["format"].toLowerCase())) { 
							object["format"] = "PDF"
						} else if (self.powerPointFormats.includes(object["format"].toLowerCase())) { // pptx,ppt,odp => powerpoint
							object["format"] = "Presentation"
							object["MSOfficeImage"] = self.MSOfficeImages[object["extension"]] ? self.MSOfficeImages[object["extension"]] : self.MSOfficeImages["powerpoint_default"];
						} else if (self.textFormats.includes(object["format"].toLowerCase())) {
							object["format"] = "text";
						} else if (self.officeFormats.includes(object["format"].toLowerCase())) {
							object["format"] = "MSOfficeDocument";
							object["MSOfficeImage"] = self.MSOfficeImages[object["extension"]] ? self.MSOfficeImages[object["extension"]] : self.MSOfficeImages["office_default"];
						} else {
							object["format"] = "application";
						}
					}
				}
				object["displayName"] = object["displayName"]?object["displayName"]:object["format"];
				var ext = object["extension"].replace(".","");
				if(docEditSupportedExtensions["view"].includes(ext)){
					object["OfficeForWebSupported"] = true;
					object["MSDocEditAllowed"] = false;
				} 
				if(docEditSupportedExtensions["edit"].includes(ext)){
					object["OfficeForWebSupported"] = true;
					object["MSDocEditAllowed"] = true;
				} else if (!docEditSupportedExtensions["view"].includes(ext) && !docEditSupportedExtensions["edit"].includes(ext)){
					object["OfficeForWebSupported"] = false;
				}
			}

			if(objectName.length > 20){
				object["objectDragName"] = objectName.slice(0, 20) + "..."
			}else{
				object["objectDragName"] = objectName
			}
		})
		return dataArray
	}

	
	setObjectKind() {
		this.allData.map(function (file) {
			if (file["format"] == "Document" || file["format"] == "SpreadSheet" || file["format"] == "Presentation" || file["format"] == "MSOfficeDocument" ) {
				file['objectKind'] = "Microsoft" + " ( " + file["format"] + " )"
			} else if (file["format"] == "Folder") {
				file['objectKind'] = "Folder"
			} else if (file["format"] == "PDF") {
				file['objectKind'] = "Adobe" + "  ( " + file["format"] + " )"
			} else if (file["format"] == "text") {
				file['objectKind'] = "text" + " ( " + file["mimeSubType"] + " )";
			} else {
				file['objectKind'] = file["mimeType"] + " ( " + file["mimeSubType"] + " )";
			}
		})
	}


	calculateSizes() {
		this.allData.map(function (object) {
			if (object["objectType"] == "FE" || object["objectType"] == "BE" || object["objectType"] == "DE" || object["objectType"] == "BB" || object["objectType"] == "SE"|| (object["objectType"] == "FR" && object["sizeInBytes"] != null)) {
				object["sizeInBytes"] = object["sizeInBytes"] ? object["sizeInBytes"] : 0; // null check added as in search results there were few files where this property is missing
				var B = parseInt(object["sizeInBytes"]);
				var KB = (B / 1024);
				var MB = KB / 1024;
				var GB = MB / 1024;
				if (MB >= 1024) {
					object["objectSize"] = (GB).toFixed(2) + " GB"
				} else if (KB >= 1024) {
					object["objectSize"] = (MB).toFixed(2) + " MB"
				} else if (B >= 1024) {
					object["objectSize"] = (KB).toFixed(2) + " KB"
				} else {
					if(B==0){
						object["objectSize"] = (B).toFixed(2) + " KB"
					}else{
						object["objectSize"] = (B).toFixed(2) + " B"
					}
					
				}
			} else {
				object["objectSize"] = "-"
			}
		})
	}

	setDuration(){
		var self = this;
		this.allData.map(function(object){
			if(object["mimeType"]=="audio"|| object["mimeType"]=="video"){
				if(object["duration"]){
					object["ObjectDuration"] = self.universalService.millisToHourMinutesAndSeconds(object["duration"]);
				}else{
					object["ObjectDuration"] = "-- : --"
				}
			}
		})
	}

	setAccessRights(dataArray){
		dataArray.map(function(object){
			var rights = object["recipientsObjRights"]
			if(rights != undefined) {
				if(rights["canEdit"] == true){
					object["editAccess"] = true
				}else if (rights["canView"] == true && rights["canEdit"] == false){
					object["editAccess"] = false
				}
			}
		})

		return dataArray;
	}

	setDefaultIconThumbnailAndIconClasses(dataArray){
		dataArray.map(function(object){
			var iconName = "";
			var defaultIconClassName = "";
			var defaultThumbnailRequired = false;
			var tileName = "";
			var type = object["format"];
			switch(type){
				case 'image':
					iconName = "no-img NeueImageFilled";
					defaultIconClassName = ""
					defaultThumbnailRequired = true;
					tileName = ""
					break;
				case 'audio':
					iconName = "NeueAudio";
					defaultIconClassName = "default-thumbnail-icon-audio"
					defaultThumbnailRequired = true
					tileName = ""
					break;
				case 'video':
					iconName = "NeueVideo";
					defaultIconClassName = "default-thumbnail-icon-video"
					defaultThumbnailRequired = true
					tileName = ""
					break;
				case 'Document':
					iconName = "NeueDocFilled";
					defaultIconClassName = "default-thumbnail-doc-icon"
					defaultThumbnailRequired = true
					tileName = "doc-tile"
					break;
				case 'Presentation':
					iconName = "NeuePPTFilled";
					defaultIconClassName = "default-thumbnail-doc-icon"
					defaultThumbnailRequired = true
					tileName = "ppt-tile"
					break;
				case 'PDF':
					iconName = "NeuePDFFilled";
					defaultIconClassName = "default-thumbnail-doc-icon"
					defaultThumbnailRequired = true;
					tileName = "pdf-tile"
					break;
				case 'SpreadSheet':
					iconName = "NeueXLSFilled";
					defaultIconClassName = "default-thumbnail-doc-icon"
					defaultThumbnailRequired = true
					tileName = "xls-tile"
					break;
				case 'text':
					iconName = "NeueTXTFilled";
					defaultIconClassName = "default-thumbnail-doc-icon"
					defaultThumbnailRequired = true
					tileName = "txt-tile"
					break;
				case 'MSOfficeDocument':
					iconName = "NeueOtherFiles";
					defaultIconClassName = "default-thumbnail-doc-icon"
					defaultThumbnailRequired = true
					tileName = "txt-tile"
					break;
				case 'application':
					iconName = "NeueOtherFiles";
					defaultIconClassName = "default-thumbnail-doc-icon"
					defaultThumbnailRequired = false
					tileName = "other-tile"
					break;
				case 'application':
					iconName = "NeueOtherFiles";
					defaultIconClassName = "default-thumbnail-doc-icon"
					defaultThumbnailRequired = false
					tileName = "other-tile"
					break;
				case 'memory':
					iconName = "no-img no-img-memory NeueImageFilled";
					defaultIconClassName = ""
					defaultThumbnailRequired = true;
					tileName = ""
					break;
			}
			object["iconName"] = iconName;
			object["defaultIconClassName"] = defaultIconClassName
			object["defaultThumbnailRequired"] = defaultThumbnailRequired
			object["tileName"] = tileName
		})

		return dataArray;
	}

	setMandatoryParamsToDisplayThubmnails() {
		var self = this;

		this.allData.map(function(object){
			let type = self.universalService.checkIfImgTypeParamIsRequired(object["mimeSubType"]);
			var imageUrl = object["imageTranscodeUrl"];
			if(imageUrl != undefined) {
				imageUrl = imageUrl.includes('?') ? imageUrl + '&' : imageUrl + '?';
				let url = imageUrl + 'size=a&apiKey=' + ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-Api-Key"] + '&devicetype=web' + type;
				if(self.universalService.currentTab == "PrivateFolder"){
					url = url + "&ppftoken="+encodeURIComponent(self.universalService.header_X_PPF_TOKEN);
				}
				object["imageTranscodeUrl"] = url;
				
			}

		});
	}

	setOwnerDetails(files){
		let self = this
		let userID = USER_DETAILS["USER_DETAILS"]["userId"];
		files.map(function(object){
		  if(object["owner"]){
			if(object["owner"]["ownerUserId"] == userID){
			  object["isLoggedInUsrFileOwner"] = true
			}else{
			  object["isLoggedInUsrFileOwner"] = false
			}
			if(userID == self.universalService.currentAlbum?.owner.ownerUserId){
			  object["isLoggedInUsrAlbumOwner"] = true
			}else{
			  object["isLoggedInUsrAlbumOwner"] = false
			}
		  }
		})
		return files;
	  }
	
}


  

